var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['csr-account__order-status', _setup._CSP_ORDER_STATUS_MAP[_setup.orderStatus]?.className]},[_vm._v(_vm._s(_setup.orderLabel))])
}
var staticRenderFns = []

export { render, staticRenderFns }